/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const actualiteSchema = z.object({
      "id": z.string(),
  "title": z.string().describe("Titre de l'actualité."),
  "slug": z.string().describe("Slug de l'actualité.")
      })